module.exports = __webpack_public_path__ + "static/media/bj_pro.ab86226f.png";